import {Repository} from '@/repositories/Base/Repository'

class ResultConversionRepository extends Repository {
    endpoint = 'mapping/result_conversion/observation'
}

export default new ResultConversionRepository()